import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';

const ReorderButton = (_param)=>{
    var { url , tabIndex  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "url",
        "tabIndex"
    ]);
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("a", swcHelpers.extends({
        href: url,
        className: "reorder-button header-menu__icon",
        tabIndex: tabIndex
    }, rest), getLabel('common.menu.reorder.button'));
};

export { ReorderButton as default };
//# sourceMappingURL=ReorderButton.js.map
